//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { uuid } from '@/assets/js/utils.js'

export default {
  props: {
    tabIndex: { // 爆仓数据详情里面用到
      type: Number, default: 0
    },
    isSelect: { // 是否展示下拉框
      type: Boolean, default: false
    },
    showSelectObj: { // 框中显示内容
      type: Object, default: () => {}
    },
    curTab: {
      type: Number,
      default: 0
    },
    isRight: { // 下拉框是否右对齐
      type: Boolean, default: true
    },
    leftText: { // 左边的文本
      type: String, default: 'EA商城'
    },
    showText: { // 左边的文本是否展示
      type: Boolean, default: true
    },
    tabsData: { // tab数据
      type: Array, default: () => []
    },
    isTranslate: { // 是否需要翻译
      type: Boolean, default: true
    },
    newIcon: {
      type: Boolean, default: false
    }
  },
  data () {
    return {
      downShow: false, // 下拉框显示隐藏
      tabsIndex: 0, // 当前选中的tab
      text: '', // 当前选中的tab name
      id: `select-${uuid()}`,
      flag: ''
    }
  },
  watch: {
    tabIndex () {
      this.text = this.tabsData[0].name
      this.tabsIndex = 0
    }
  },
  created () {
    this.text = this.tabsData[0]?.name
  },
  mounted () {
    document.addEventListener('click', this.closeDrop)
    this.tabsIndex = this.tabIndex
    this.text = this.tabsData[this.tabIndex]?.name
  },
  beforeDestroy () {
    document.removeEventListener('click', this.closeDrop)
  },
  methods: {
    showDrop () {
      this.downShow = !this.downShow
      if (this.$store.state.isMobile) {
        if (this.downShow) {
        // 监听点击非组件区域关闭下拉框
          document.body.style.overflow = 'hidden'
        } else {
          document.body.style.overflow = 'auto'
        }
      } else document.body.style.overflow = 'auto'
    },
    // 点击非组件区域关闭下拉框
    closeDrop (e = {}) {
      console.log('进来了~~~~~~~~~~')
      const dom = document.getElementById(this.id)
      if (!dom?.contains(e?.target)) {
        this.downShow = false
        if (this.$store.state.isMobile) {
          document.body.style.overflow = 'auto' // 点击选项后恢复滚动
        }
      }
    },
    handleClick (name = '', index = 0) {
      console.log('handleClick', this.showSelectObj, name, index)
      this.$emit('mobileTab', { name, code: this.showSelectObj?.code, area: index })
      this.tabsIndex = index
      this.text = name
      this.downShow = false
      if (this.$store.state.isMobile) {
        document.body.style.overflow = 'auto' // 点击选项后恢复滚动
      }
    }
  }
}
